import React, { useEffect, useState } from "react";
import axios from '../../api/api';
import { useParams } from 'react-router-dom';
import logo from '../../components/images/MawinguAirtime1.png'

const TransactionInvoice = () => {

  const { id } = useParams()
  const [invoice,setInvoice] = useState([])

  useEffect(() => {
    const getInvoiceDetails = async() => {
      try {
        const response = await axios.get(`/topup/bank/${id}`)
        setInvoice(response.data)
      } catch (error) {
        console.log(error)
      }
    }
    getInvoiceDetails()
  },[id])

  const handlePrint = ()=> {
    const content = document.getElementById('print-content');
    
    if (content) {
      const originalContents = document.body.innerHTML;
      document.body.innerHTML = content.innerHTML;
      window.print();
      document.body.innerHTML = originalContents;
    } else {
      console.error("Element with id 'print-content' not found or not an HTMLElement");
    }
  };



  return (
    <div className='mx-auto p-6 flex items-center justify-center'>
      <div className='bg-white shadow-lg rounded-lg w-full md:w-4/5 xl:w-3/5'>
        <div id='print-content' className='p-6'>
          <div className="flex items-center justify-between mb-6">
            <div>
              <img className='h-20' src={logo} alt="" />
              <h3 className='text-xl font-medium text-gray-600'>Invoice Receipt</h3>
            </div>
            <div>
              <h4 className='font-semibold text-gray-700'>Invoice NO: <span className='font-normal'>{invoice.transaction_id}</span></h4>
              <h4 className='font-semibold text-gray-700'>Client: <span className='font-normal'>{invoice.client}</span></h4>
              <h4 className='font-semibold text-gray-700'>Account: <span className='font-normal'>{invoice.service_client}</span></h4>
            </div>
          </div>
          <div className="mb-6">
            <h4 className='font-semibold text-gray-700'>Invoice By: <span className='font-normal'>{invoice.created_by}</span></h4>
            <h4 className='font-semibold text-gray-700'>Date: <span className='font-normal'>{invoice.created_at ? new Date(invoice.created_at).toLocaleString("en-CA", { hour12: false }) : "N/A"}</span></h4>
          </div>
          <div className='overflow-x-auto'>
            <table className="w-full bg-gray-100 border border-gray-300 rounded-lg shadow-sm">
              <thead className='bg-gray-200'>
                <tr>
                  <th className='px-4 py-2 text-left text-gray-600'>Description</th>
                  <th className='px-4 py-2 text-left text-gray-600'>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr className='border-t'>
                  <td className='px-4 py-2'>{invoice.remarks}</td>
                  <td className='px-4 py-2 font-medium text-gray-800'>KSH {invoice.amount_credited?.toLocaleString()}</td>
                </tr>
                <tr className='border-t'>
                  <td className='px-4 py-2'>Commission</td>
                  <td className='px-4 py-2 font-medium text-gray-800'>{invoice.commissions}%</td>
                </tr>
                <tr className='border-t'>
                  <td className='px-4 py-2'>Units</td>
                  <td className='px-4 py-2 font-medium text-gray-800'>{invoice.units?.toLocaleString()}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className='flex justify-end p-6'>
          <button onClick={handlePrint} className='bg-blue-600 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-700 transition duration-200'>Save Invoice</button>
        </div>
      </div>
    </div>

  )
}

export default TransactionInvoice
